export default function PrivacyPage() {
  return (
    <div className="py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">سياسة الخصوصية</h1>
        <p className="text-gray-500 text-sm mb-8">Privacy Policy</p>

        <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 space-y-8">
          {/* Intro */}
          <section>
            <p className="text-sm text-gray-700 leading-relaxed">
              نلتزم في رمبا بحماية خصوصيتك. توضح هذه السياسة كيفية جمع واستخدام وحماية بياناتك الشخصية.
            </p>
          </section>

          {/* 1. Data Collection */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">1. البيانات التي نجمعها</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>رقم الهاتف - للتسجيل والتواصل</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>معلومات السيارة - النوع، اللون، رقم اللوحة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>صورة السيارة - للتحقق من الملكية</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>الموقع الجغرافي - لعرض المغاسل القريبة (بإذنك)</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>بصمة الجهاز - لأمان رمز QR ومنع الاحتيال</span>
              </li>
            </ul>
          </section>

          {/* 2. Usage */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">2. كيف نستخدم بياناتك</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>تقديم خدمة غسيل السيارات وإدارة اشتراكك</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>إرسال إشعارات حول حالة سيارتك في الطابور</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>عرض المغاسل القريبة من موقعك</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>التحقق من هوية السيارة ومنع الاحتيال</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>تحسين الخدمة وتحليل أنماط الاستخدام</span>
              </li>
            </ul>
          </section>

          {/* 3. Sharing */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">3. مشاركة البيانات</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>لن نشارك بياناتك مع أطراف ثالثة لأغراض تسويقية</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>قد نشارك معلومات محدودة مع المغاسل الشريكة (اسم، رقم لوحة، نوع السيارة) لتقديم الخدمة</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>قد نشارك البيانات عند الطلب القانوني من الجهات المختصة</span>
              </li>
            </ul>
          </section>

          {/* 4. Storage */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">4. تخزين البيانات</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>نستخدم خوادم آمنة لتخزين بياناتك</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>الصور مخزنة بشكل آمن على Cloudflare R2</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>نحتفظ ببياناتك طالما كان اشتراكك نشطاً</span>
              </li>
            </ul>
          </section>

          {/* 5. Rights */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">5. حقوقك</h2>
            <ul className="space-y-2 text-sm text-gray-700">
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>يمكنك طلب حذف حسابك وبياناتك في أي وقت</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>يمكنك إيقاف إشعارات الموقع من إعدادات جهازك</span>
              </li>
              <li className="flex gap-2">
                <span className="text-primary-600 font-bold shrink-0">-</span>
                <span>لأي استفسار حول بياناتك، تواصل معنا</span>
              </li>
            </ul>
          </section>

          {/* 6. Updates */}
          <section>
            <h2 className="text-lg font-bold text-gray-900 mb-3">6. تحديث السياسة</h2>
            <p className="text-sm text-gray-700">
              قد نقوم بتحديث هذه السياسة من وقت لآخر. سنعلمك بأي تغييرات جوهرية عبر التطبيق.
            </p>
          </section>

          {/* Last Updated */}
          <div className="pt-4 border-t border-gray-100">
            <p className="text-xs text-gray-400 text-center">آخر تحديث: فبراير ٢٠٢٦</p>
          </div>
        </div>
      </div>
    </div>
  );
}
